import { createContext, useContext } from "react";

export const CivitaAssistantContext = createContext(null);

export function useCivitaAssistant() {
  const value = useContext(CivitaAssistantContext);
  if (!value) {
    throw new Error("useCivitaAssistant debe usarse dentro de CivitaAssistantProvider");
  }
  return value;
}
